/** @format */
import React from 'react';
import moment from 'moment';
import appConfig from 'config/app';
import { useSelector } from 'react-redux';

export const ExpandableTableRow = ({ rowData, rowMeta }) => {
  const { dataIndex } = rowMeta || {};

  const leadsData = useSelector((state) => state.leads);
  const data = leadsData.data[dataIndex];

  const ListItem = ({
    label,
    value,
    unit = null,
    type = null,
    data = {},
    valueKey = undefined
  }) => {
    if (value) {
      if (type) {
        switch (type) {
          case 'date': {
            return (
              <li>
                <span>{label} : </span>
                {moment(value).format(appConfig.defaultMomentDateTimeFormat)}
              </li>
            );
          }

          case 'para': {
            return (
              <li>
                <p>{value}</p>
              </li>
            );
          }
          case 'fm_object_profile': {
            return (
              <li>
                <div className='button-item-container'>
                  <span>{label} : </span>
                  <p>{value}</p>{' '}
                  <button
                    className='btn btn-pink'
                    onClick={() => {
                      window.open(
                        `https://friamaklare.se/objekt/${data?.objectId}`,
                        '_blank'
                      );
                    }}>
                    View Object
                  </button>
                </div>
              </li>
            );
          }
          case 'urgency': {
            if (valueKey === 'urgent') {
              return (
                <li
                  style={{
                    color: 'red'
                  }}>
                  <span>{label} : </span>
                  {value}
                </li>
              );
            } else {
              return (
                <li>
                  <span>{label} : </span>
                  {value}
                </li>
              );
            }
          }
          default: {
            return (
              <li>
                <span>{label} : </span>
                {value}
              </li>
            );
          }
        }
      } else {
        if (Array.isArray(value)) {
          if (value.length > 0) {
            return (
              <li>
                <span>{label} : </span>
                {value.join(',')}
              </li>
            );
          }
        } else {
          return (
            <li>
              <span>{label} : </span>
              {value} {unit && <span>{unit}</span>}
            </li>
          );
        }
      }
    }
  };

  return (
    <tr className='leads-data-row-expanded'>
      <td colSpan={rowData.length + 1}>
        <div className='leads-data-row-expanded-container'>
          <ul>
            <ListItem
              label='Lead came from'
              value={data?.source}
              type={data?.sourceKey}
              data={data}
            />
            <ListItem label='Broker Status' value={data?.brokerStatus} />
            <ListItem
              label='Received at'
              value={data?.createdDatetime}
              type='date'
            />
            <ListItem label='Email' value={data?.email} />
            <ListItem label='Phone' value={data?.extra?.phone} />
            <ListItem label='Location' value={data?.location} />
            <ListItem label='Address' value={data?.extra?.address} />
            <ListItem
              label='Number Of rooms'
              value={data?.extra?.numberOfRooms}
            />
            <ListItem
              label='Sq meters'
              value={data?.extra?.sqMeters}
              unit='kvm'
            />
            <ListItem
              label='Urgency'
              value={data?.extra?.urgency}
              valueKey={data?.urgencyKey}
              type='urgency'
            />
            <ListItem
              label='Property types'
              value={data?.extra?.propertyTypes}
            />
            <ListItem value={data?.details} type='para' />
          </ul>
        </div>
      </td>
    </tr>
  );
};
